const DataProfile = [
    {
        comment: [   
        'Sophie is a qualified Landscape Architect (BLA UNSW) and horticulturalist. With years designing residential gardens in Sydney her work focuses on strong shapes and proportion matched with carefully selected materials to suit the site conditions and client brief.Sophie has a broad depth of knowledge and experience as well as enthusiasm for designing beautiful gardens which has been rewarded with numerous peer judged design awards.',
        'Together with Mick their complementary experience provides a wealth of skills, passion and knowledge to take your garden from concept to reality.' 
        ],
        description:'Sophie is a qualified Landscape Architect (BLA UNSW) and horticulturalist. With years designing residential gardens in Sydney her work focuses on strong shapes and proportion matched with carefully selected materials to suit the site conditions and client brief. ',
        emailId: 'sophie@thinkoutsidegardens.com.au',
        id: 'Modal-Sophie', 
        label: 'Modal-Sophie',
        link:'/Modal-Sophie',
        phone: '0293807957',
        phoneDisplay: '(02) 9380 7957',
        occupation: 'Landscape Architect',
        title: 'Sophie Grieve'
        
    },
    {
        comment: ['Think Outside Gardens owner and director Mick Drower has worked building residential gardens for close to twenty years both in Sydney and abroad. Holding a degree in business administration Mick has extensive experience in structural landscaping and the coordination of jobs. From interpreting the design to managing suppliers and materials, he offers intelligent and practical solutions, keeping you informed at every stage of the project.', 
        'Delivering a trusted and personalised service, you are dealing with the director and decision maker at every stage of the project.'], 
        description: 'Think Outside Gardens owner and director Mick Drower has worked building residential gardens for close to twenty years both in Sydney and abroad.',
        emailId: 'mick@thinkoutsidegardens.com.au',
        id: 'Modal-Mick-Drower', 
        label: 'exampleModalLabel',
        link:'/Modal-Mick-Drower',
        phone: '0293807957',
        phoneDisplay: '(02) 9380 7957',
        occupation: 'Director',
        title: 'Mark Drower'
    }
]

export default DataProfile;
